import { render, staticRenderFns } from "./purcontrolsubject.vue?vue&type=template&id=73951d18&scoped=true&"
import script from "./purcontrolsubject.vue?vue&type=script&lang=js&"
export * from "./purcontrolsubject.vue?vue&type=script&lang=js&"
import style0 from "./purcontrolsubject.vue?vue&type=style&index=0&id=73951d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73951d18",
  null
  
)

export default component.exports